import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import PagesHeroSection from '../../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../../utils/hoc/SEOUpdater';

import '../immigrationPage/immigrationPage.scss';
import { Col, Row } from 'react-bootstrap';

const EmploymentLawPage = () => {
  const { t } = useTranslation('employmentLaw');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      <SEOUpdater page="employmentLaw" />
      <PagesHeroSection page={t('pageTitle')} />

      <div className="services-section text-center">
        <div className="container">
          <h2 className="section-title">{t('heroTitle')}</h2>
          <p>
            <Trans i18nKey="intro.p1" t={t} components={{ 1: <b /> }} />
          </p>
          <p>
            <Trans i18nKey="intro.p2" t={t} components={{ 1: <b /> }} />
          </p>
          <div className="underline mx-auto mb-4"></div>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          <Row>
            <Col md={6}>
              <h3>{t('sections.unpaidWages.title')}</h3>
              <p>{t('sections.unpaidWages.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.sexualHarassment.title')}</h3>
              <p>{t('sections.sexualHarassment.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.whistleblower.title')}</h3>
              <p>{t('sections.whistleblower.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.wrongfulTermination.title')}</h3>
              <p>{t('sections.wrongfulTermination.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.laborLawViolations.title')}</h3>
              <p>{t('sections.laborLawViolations.text')}</p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default EmploymentLawPage;
